// extracted by mini-css-extract-plugin
export default {"content":"BbOhM","cards":"Oot62","slider-container":"ISrm5"};